import { QRCodeCanvas } from 'qrcode.react';
import { memo } from 'react';

interface QRCodeProps {
  url: string;
}

export const QRCode = memo(({ url }: QRCodeProps) => {
  if (!url) return <></>;
  return (
    <QRCodeCanvas
      value={url}
      size={128}
      level={'L'}
      imageSettings={{
        src: '/favicon.ico',
        x: undefined,
        y: undefined,
        height: 24,
        width: 24,
        excavate: true,
      }}
    />
  );
});
